import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  Row,
} from "react-bootstrap";
import Modal from "react-modal";
import {
  saveImageToFirebaseStorage,
  utilUpdateDocument,
  utilUpdateTables,
} from "../../../util/UtilsFirebase";
import { State, City } from "country-state-city";
import "./ConfigTrucks.css";

export default function ConfigTrucks() {
  const { register, setRegister } = useAuthContext();
  const [registro, setRegistro] = useState({
    equivalenciapuntos: 1,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [imageticket, setImageTicket] = useState(null);
  const [infoModal, setInfoModal] = useState(false);
  const [textInfo, setTextInfo] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [imageUrlTicket, setImageUrlTicket] = useState(null);
  const customModalStyles = {
    content: {
      width: "600px",
      height: "200px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };
  const customModalInfoStyles = {
    content: {
      width: "600px",
      height: "150px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };

  useEffect(() => {
    setRegistro(register);
    setImageUrl(register.img);
    setImageUrlTicket(register.imgticket);
  }, [register]);

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      if (e.target.name !== "pagar_en_linea" && e.target.name !== "limitecom") {
        setRegistro({
          ...registro,
          [e.target.name]: e.target.checked,
        });
      } else if (
        e.target.name === "limitecom" &&
        e.target.checked === true &&
        !registro.tiempocom
      ) {
        setRegistro({
          ...registro,
          [e.target.name]: true,
          tiempocom: "5",
        });
      } else {
        if (registro.AT && registro.MPK) {
          setRegistro({
            ...registro,
            [e.target.name]: e.target.checked,
          });
        } else {
          alert(
            "Ingresa las credenciales de Mercado Pago para acceder a esta opcion",
          );
          setRegistro({
            ...registro,
            [e.target.name]: false,
          });
        }
      }
    } else if (e.target.name === "estado") {
      setRegistro({
        ...registro,
        [e.target.name]: e.target[e.target.selectedIndex].innerText,
        estadoCode: e.target.value,
      });
    } else {
      if (e.target.value === "true") {
        setRegistro({
          ...registro,
          [e.target.name]: true,
        });
      } else if (e.target.value === "false") {
        setRegistro({
          ...registro,
          [e.target.name]: false,
        });
      } else {
        setRegistro({
          ...registro,
          [e.target.name]: e.target.value,
        });
      }
    }
    console.log(registro);
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const selectedImage = e.target.files[0];

      // Read the image file and create a preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(selectedImage);
        setImageUrl(reader.result);
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const handleImageChangeTicket = (e) => {
    if (e.target.files[0]) {
      const selectedImage = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageTicket(selectedImage);
        setImageUrlTicket(reader.result);
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const handleCancelModal = () => {
    console.log("Envío del formulario cancelado");
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleInfo = async (e) => {
    setTextInfo(e.target.title);
    setInfoModal(true);
  };

  const handleConfirmModal = async () => {
    if (registro.limitecom && parseInt(registro.tiempocom) <= 0) {
      alert("Ingrese un tiempo valido para limitar las comandas");
      setIsModalOpen(false);
      return;
    }
    if (image) {
      let path = "truck/" + registro.id;
      const downloadURL = await saveImageToFirebaseStorage(path, image);
      if (downloadURL) {
        setImageUrl(downloadURL);
      }
      registro.img = downloadURL;
    }
    if (imageticket) {
      let path = "truck/" + registro.id;
      const downloadURL = await saveImageToFirebaseStorage(path, imageticket);
      if (downloadURL) {
        setImageUrlTicket(downloadURL);
      }
      registro.imgticket = downloadURL;
    }
    await utilUpdateDocument("registro", registro.id, registro);
    setIsModalOpen(false);
    setRegister(registro);
    utilUpdateTables(registro.table, registro.id);
  };
  return (
    <div className="row">
      <h2 className="page-title">CONFIGURACION</h2>
      <div className="tabs">
        <div className="tab-container">
          {register.type === "truck" && (
            <div id="tab6" className="tab">
              <a href="#tab6">Plaza</a>
              <div className="tab-content">
                <div className="project-list">
                  <Form>
                    <Container>
                      <Row>
                        <Col md={12}>
                          <Form.Group controlId="razonSocial">
                            {/* {!registro.admin ? ( */}
                            <Form.Label>
                              Registrate a una plaza con el siguiente codigo:
                              <br />
                              {" " + register.id}
                              <br />
                              <br />
                              Comparte el codigo con el administrador de la
                              plaza para que te registre.
                            </Form.Label>
                            {/* ) : (
                               <Form.Label>
                                 Ya te encuentras asociado a una plaza
                               </Form.Label>
                             )}*/}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </div>
              </div>
            </div>
          )}
          <div id="tab5" className="tab">
            <a href="#tab5">Datos pago</a>
            <div className="tab-content">
              <div className="project-list">
                <Form>
                  <Container>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="MPK">
                          <Form.Label>
                            PUBLIC KEY:{" "}
                            <i
                              title="Llave publica otorgada por mercado pago"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.MPK}
                            name="MPK"
                            required
                            type="password"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="AT">
                          <Form.Label>
                            ACCESS TOKEN:{" "}
                            <i
                              title="Token de acceso otorgado por mercado pago"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.AT}
                            name="AT"
                            required
                            type="password"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </div>
            </div>
          </div>
          <div id="tab4" className="tab">
            <a href="#tab4">Menu ticket</a>
            <div className="tab-content">
              <div className="project-list">
                <Form>
                  <h3 className="center">OPCIONES</h3>
                  <hr />
                  <Container>
                    <Row>
                      <Col md={6}>
                        <Row>
                          <Col md={5}></Col>
                          <Col md={7}>
                            <div className="form-switch">
                              <label className="lblqrdinamico">RESEÑA</label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={registro.Tresena}
                                onChange={handleChange}
                                name="Tresena"
                                id="flexSwitchCheckDefault"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={6}>
                        <Row>
                          <Col md={7}>
                            <div className="form-switch">
                              <label className="lblqrdinamico">
                                FACTURACION
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={registro.Tfacturacion}
                                onChange={handleChange}
                                name="Tfacturacion"
                                id="flexSwitchCheckDefault"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4}></Col>
                      <Col md={4}>
                        <div className="form-switch">
                          <label className="lblqrdinamico">PUNTOS</label>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={registro.Tpuntos}
                            onChange={handleChange}
                            name="Tpuntos"
                            id="flexSwitchCheckDefault"
                          />
                        </div>
                      </Col>
                      <Col md={4}></Col>
                    </Row>
                    <br />
                  </Container>
                </Form>
              </div>
            </div>
          </div>
          <div id="tab3" className="tab">
            <a href="#tab3">Datos ticket</a>
            <div className="tab-content">
              <div className="project-list">
                <Form>
                  <Container>
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Nombre comercial:{" "}
                            <i
                              title="Nombre del negocio que se mostrara en el ticket de venta"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.nameticket}
                            name="nameticket"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            RFC:{" "}
                            <i
                              title="RFC del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.rfcticket}
                            name="rfcticket"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            País:{" "}
                            <i
                              title="Pais donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.paisticket}
                            name="paisticket"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Estado:{" "}
                            <i
                              title="Estado donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.estadoticket}
                            name="estadoticket"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Municipio:{" "}
                            <i
                              title="Municipio donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.municipioticket}
                            name="municipioticket"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Sucursal:
                            <i
                              title="Nombre de la sucursal"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.sucursalticket}
                            type="text"
                            onChange={handleChange}
                            name="sucursalticket"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="Telefono">
                          <Form.Label>
                            Telefono sucursal:
                            <i
                              title="Telefono de la sucursal"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.phoneticket}
                            type="number"
                            onChange={handleChange}
                            name="phoneticket"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                </Form>
                <Form>
                  <div className="">
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Razon Social:
                            <i
                              title="Razon social del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.razon_socialticket}
                            name="razon_socialticket"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="Calle">
                          <Form.Label>
                            Calle:
                            <i
                              title="Calle donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.calleticket}
                            type="text"
                            onChange={handleChange}
                            name="calleticket"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="Colonia">
                          <Form.Label>
                            Colonia:
                            <i
                              title="Colonia donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.coloniaticket}
                            type="text"
                            onChange={handleChange}
                            name="coloniaticket"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="Numero domicilio">
                          <Form.Label>
                            Numero del domicilio:
                            <i
                              title="Numero de domicilio del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.numdomticket}
                            type="text"
                            onChange={handleChange}
                            name="numdomticket"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="Codigo postal">
                          <Form.Label>
                            Codigo postal:
                            <i
                              title="Codigo postal del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.codigopticket}
                            type="text"
                            onChange={handleChange}
                            name="codigopticket"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <Form.Group controlId="modoOP">
                    <div className="center">
                      <label>
                        Logo:{" "}
                        <i
                          title="Logo que se mostrara en el ticket de venta"
                          className="bx bxs-info-circle icon bx-xs"
                          onClick={handleInfo}
                        ></i>
                        <img
                          id="logo_img"
                          alt="Error al cargar imagen"
                          src={imageUrlTicket}
                          height="150"
                          width="275"
                        />
                        <input
                          id="logoNegTicket"
                          type="file"
                          style={{ display: "none" }}
                          accept="image/png, image/jpeg"
                          multiple={false}
                          onChange={handleImageChangeTicket}
                        />
                      </label>
                    </div>
                  </Form.Group>
                </Form>
              </div>
            </div>
          </div>
          <div id="tab2" className="tab">
            <a href="#tab2">Mi app</a>
            <div className="tab-content">
              <Form>
                <h3 className="center">BOTONES</h3>
                <hr />
                <Container>
                  <Row>
                    {register.type === "restaurant" ? (
                      <>
                        <Col md={6}>
                          <Row>
                            <Col md={5}></Col>
                            <Col md={7}>
                              <div className="form-switch">
                                <label className="lblqrdinamico">MENSAJE</label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.mensaje}
                                  onChange={handleChange}
                                  name="mensaje"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={7}>
                              <div className="form-switch">
                                <label className="lblqrdinamico">PAGAR</label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.pagar}
                                  onChange={handleChange}
                                  name="pagar"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                            <Col md={5}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group
                                    controlId="razonSocial"
                                    id="checkmodo"
                                    className="center"
                                  >
                                    Tarjeta
                                    <FormControl
                                      className="form-check-input"
                                      style={{ marginLeft: "0px !important" }}
                                      type="checkbox"
                                      checked={registro.tarjeta}
                                      onChange={handleChange}
                                      name="tarjeta"
                                      id="btncheckBtns"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group
                                    controlId="razonSocial"
                                    id="checkmodo"
                                    className="center"
                                  >
                                    Efectivo
                                    <FormControl
                                      className="form-check-input"
                                      style={{ marginLeft: "0px !important" }}
                                      type="checkbox"
                                      checked={registro.efectivo}
                                      onChange={handleChange}
                                      name="efectivo"
                                      id="btncheckBtns"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={5}></Col>
                            <Col md={7}>
                              <div className="form-switch">
                                <label className="lblqrdinamico">
                                  CALIFICAR MESEROS
                                </label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.cal_mesero}
                                  onChange={handleChange}
                                  name="cal_mesero"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={7}>
                              <div className="form-switch">
                                <label className="lblqrdinamico">
                                  NO MOLESTAR
                                </label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.no_molestar}
                                  onChange={handleChange}
                                  name="no_molestar"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                    <Col md={6}>
                      <Row>
                        <Col md={5}></Col>
                        <Col md={7}>
                          <div className="form-switch">
                            <label className="lblqrdinamico">
                              CALIFICAR {register.type.toUpperCase()}
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={registro.cal_restaurante}
                              onChange={handleChange}
                              name="cal_restaurante"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col md={7}>
                          <div className="form-switch">
                            <label className="lblqrdinamico">MENU</label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={registro.menu}
                              onChange={handleChange}
                              name="menu"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </Col>
                        <Col md={5}>
                          <Row>
                            <Col md={6}>
                              <Form.Group
                                controlId="razonSocial"
                                id="checkmodo"
                                className="center"
                              >
                                Carta
                                <FormControl
                                  className="form-check-input"
                                  style={{ marginLeft: "0px !important" }}
                                  type="checkbox"
                                  checked={registro.carta}
                                  onChange={handleChange}
                                  name="carta"
                                  id="btncheckBtns"
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group
                                controlId="razonSocial"
                                id="checkmodo"
                                className="center"
                              >
                                Digital
                                <FormControl
                                  className="form-check-input"
                                  style={{ marginLeft: "0px !important" }}
                                  type="checkbox"
                                  checked={registro.digital}
                                  onChange={handleChange}
                                  name="digital"
                                  id="btncheckBtns"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col md={5}></Col>
                        <Col md={7}>
                          <div className="form-switch">
                            <label className="lblqrdinamico">
                              ENVIAR COMANDA
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={registro.enviar}
                              onChange={handleChange}
                              name="enviar"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col md={7}>
                          <div className="form-switch">
                            <label className="lblqrdinamico">
                              PAGAR EN LINEA
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={
                                registro.AT && registro.MPK
                                  ? registro.pagar_en_linea
                                  : false
                              }
                              onChange={handleChange}
                              name="pagar_en_linea"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    {register.type === "restaurant" ? (
                      <>
                        <Col md={6}>
                          <Row>
                            <Col md={5}></Col>
                            <Col md={7}>
                              <div className="form-switch">
                                <Form.Control
                                  onChange={handleChange}
                                  value={registro.BtnCus1}
                                  name="BtnCus1"
                                  required
                                  type="text"
                                />
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.Btn1}
                                  onChange={handleChange}
                                  name="Btn1"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={7}>
                              <div className="form-switch">
                                <Form.Control
                                  onChange={handleChange}
                                  value={registro.BtnCus2}
                                  name="BtnCus2"
                                  required
                                  type="text"
                                />
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.Btn2}
                                  onChange={handleChange}
                                  name="Btn2"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={5}></Col>
                            <Col md={7}>
                              <div className="form-switch">
                                <Form.Control
                                  onChange={handleChange}
                                  value={registro.BtnCus3}
                                  name="BtnCus3"
                                  required
                                  type="text"
                                />
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.Btn3}
                                  onChange={handleChange}
                                  name="Btn3"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={7}>
                              <div className="form-switch">
                                <Form.Control
                                  onChange={handleChange}
                                  value={registro.BtnCus4}
                                  name="BtnCus4"
                                  required
                                  type="text"
                                />
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={registro.Btn4}
                                  onChange={handleChange}
                                  name="Btn4"
                                  id="flexSwitchCheckDefault"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={4}></Col>
                        <Col md={4}>
                          <div className="form-switch">
                            <Form.Control
                              onChange={handleChange}
                              value={registro.BtnCus5}
                              name="BtnCus5"
                              required
                              type="text"
                            />
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={registro.Btn5}
                              onChange={handleChange}
                              name="Btn5"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </Col>
                        <Col md={4}></Col>
                      </>
                    ) : (
                      <></>
                    )}
                  </Row>
                  <br />
                </Container>
              </Form>
            </div>
          </div>
          <div id="tab1" className="tab">
            <a href="#tab1">Mi negocio</a>
            <div className="tab-content">
              <div className="project-list">
                <Form>
                  <Container>
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Nombre comercial:{" "}
                            <i
                              title="Nombre del negocio (Se usara para mostrar el negocio en la aplicacion)"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.name}
                            name="name"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Alias:{" "}
                            <i
                              title="Alias del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.alias}
                            name="alias"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            RFC:{" "}
                            <i
                              title="RFC (Registro federal del contribuyente) del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.rfc}
                            name="rfc"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="Telefono">
                          <Form.Label>
                            Telefono:{" "}
                            <i
                              title="Telefono del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.phone}
                            type="number"
                            onChange={handleChange}
                            name="phone"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            País:{" "}
                            <i
                              title="País donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.pais}
                            readOnly
                            name="pais"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Estado:{" "}
                            <i
                              title="Estado donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Select
                            value={registro.estadoCode}
                            onChange={handleChange}
                            name="estado"
                          >
                            {State.getStatesOfCountry("MX").map(
                              (item, index) => (
                                <option key={index} value={item.isoCode}>
                                  {item.name}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Municipio:{" "}
                            <i
                              title="Municipio donde se ubica el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Select
                            value={registro.ciudad}
                            onChange={handleChange}
                            name="ciudad"
                          >
                            {City.getCitiesOfState(
                              "MX",
                              registro.estadoCode,
                            ).map((item, index) => (
                              <option key={index} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      {register.type === "restaurant" ? (
                        <Col md={6}>
                          <Form.Group controlId="razonSocial">
                            <Form.Label>
                              Mesas:{" "}
                              <i
                                title="Numero de mesas que maneja el negocio"
                                className="bx bxs-info-circle icon bx-xs"
                                onClick={handleInfo}
                              ></i>
                            </Form.Label>
                            <FormControl
                              value={registro.table}
                              type="number"
                              min={0}
                              onChange={handleChange}
                              name="table"
                            />
                          </Form.Group>
                        </Col>
                      ) : (
                        <></>
                      )}
                      <Col md={6}>
                        <Row>
                          <label
                            style={{
                              paddingTop: 30,
                              paddingBottom: 0,
                              marginBottom: 0,
                            }}
                          >
                            Equivalencia de puntos{" "}
                            <i
                              title="Asignacion de cuanto vale un punto en dinero"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </label>
                          <Col
                            md={5}
                            style={{
                              paddingRight: 0,
                              paddingLeft: 15,
                            }}
                          >
                            <label
                              style={{
                                paddingLeft: 0,
                                paddingTop: 0,
                                marginLeft: 0,
                                paddingBottom: 0,
                                marginTop: 10,
                              }}
                            >
                              {""}1 punto = $ 1.00
                            </label>
                          </Col>
                          {/* <Col md={7} style={{ paddingLeft: 0, paddingTop: 3 }}>
                            <Form.Group controlId="razonSocial">
                              <FormControl
                                value={1}
                                type="number"
                                min={1}
                                disabled="disabled"
                                // onChange={handleChange}
                                name="equivalenciapuntos"
                              />
                            </Form.Group>
                          </Col> */}
                        </Row>
                      </Col>
                      <Col md={6}>
                        <Form.Group
                          controlId="fronterizo"
                          id="checkmodo"
                          className="center"
                        >
                          <Form.Label title="El negocio se encuentra en franja fornteriza">
                            IVA.{" "}
                            <i
                              title="Asignacion del IVA que maneja el negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Select
                            title="IVA que maneja el negocio"
                            value={registro.frontera}
                            onChange={handleChange}
                            name="frontera"
                            id=""
                          >
                            <option value={"true"}>16%</option>
                            <option value={"false"}>8%</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <div className="form-switch">
                          <label htmlFor="">
                            Mostrar negocio en busqueda{" "}
                            <i
                              title="Opcion para mostrar el negocio en el buscador principal de la aplicacion"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={registro.busqueda}
                            onChange={handleChange}
                            name="busqueda"
                            id="flexSwitchCheckDefault"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row></Row>
                  </Container>
                </Form>
                <Form>
                  <div className="">
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="razonSocial">
                          <Form.Label>
                            Razon Social:{" "}
                            <i
                              title="Razon social del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            onChange={handleChange}
                            value={registro.razon_social}
                            name="razon_social"
                            required
                            type="text"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group controlId="Direccion">
                          <Form.Label>
                            Direccion:{" "}
                            <i
                              title="Direccion del negocio"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            value={registro.direccion}
                            type="text"
                            onChange={handleChange}
                            name="direccion"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "-webkit-center" }}>
                      <Col md={6}>
                        <Form.Group controlId="Direccion">
                          <Form.Label>
                            Limitar comandas pendientes:{" "}
                            <i
                              title="Establezca un tiempo limite para que se venzan las comandas pendientes"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <FormControl
                            checked={registro.limitecom}
                            type="checkbox"
                            className="form-check-input"
                            style={{ marginLeft: "0px !important" }}
                            onChange={handleChange}
                            id="btncheckMode"
                            name="limitecom"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group controlId="Direccion">
                          <Form.Label>
                            Tiempo limite(minutos):{" "}
                            <i
                              title="Tiempo limite para que se venzan las comandas pendientes"
                              className="bx bxs-info-circle icon bx-xs"
                              onClick={handleInfo}
                            ></i>
                          </Form.Label>
                          <Form.Control
                            value={registro.tiempocom ? registro.tiempocom : 5}
                            type="number"
                            onChange={handleChange}
                            min={0}
                            name="tiempocom"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    {register.type === "restaurant" ? (
                      <Row>
                        <div className="center">
                          <h3>Modo de operacion para meseros:</h3>
                        </div>
                        <Col md={4}>
                          <Form.Group
                            controlId="razonSocial"
                            id="checkmodo"
                            className="center"
                          >
                            <Form.Label title="Los meseros se encargan de mesas especificas">
                              Individual
                              <i
                                title="Los meseros se encargan de mesas especificas"
                                className="bx bxs-info-circle icon bx-xs"
                                onClick={handleInfo}
                              ></i>
                            </Form.Label>
                            <FormControl
                              title="Los meseros se encargan de mesas especificas"
                              className="form-check-input"
                              style={{ marginLeft: "0px !important" }}
                              type="checkbox"
                              checked={registro.individual}
                              onChange={handleChange}
                              name="individual"
                              id="btncheckMode"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group
                            controlId="Direccion"
                            id="checkmodo"
                            className="center"
                          >
                            <Form.Label title="Multiples meseros atienden las mesas">
                              Grupal{" "}
                              <i
                                title="Multiples meseros atienden las mesas"
                                className="bx bxs-info-circle icon bx-xs"
                                onClick={handleInfo}
                              ></i>
                            </Form.Label>
                            <FormControl
                              title="Multiples meseros atienden las mesas"
                              className="form-check-input"
                              style={{ marginLeft: "0px !important" }}
                              type="checkbox"
                              checked={registro.grupal}
                              onChange={handleChange}
                              name="grupal"
                              id="btncheckMode"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group
                            controlId="Direccion"
                            id="checkmodo"
                            className="center"
                          >
                            <Form.Label title="Los meseros se rotan las mesas">
                              Rotacion{" "}
                              <i
                                title="Los meseros se rotan las mesas"
                                className="bx bxs-info-circle icon bx-xs"
                                onClick={handleInfo}
                              ></i>
                            </Form.Label>
                            <FormControl
                              title="Los meseros se rotan las mesas"
                              className="form-check-input"
                              style={{ marginLeft: "0px !important" }}
                              type="checkbox"
                              checked={registro.rotacion}
                              onChange={handleChange}
                              name="rotacion"
                              id="btncheckMode"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    ) : (
                      <></>
                    )}

                    <Row hidden>
                      <Col md={6}>
                        <Form.Group controlId="numMesas">
                          <Form.Label>Ubicacion:</Form.Label>
                          <select
                            value={registro.location}
                            disabled
                            onChange={handleChange}
                            name="location"
                          >
                            <option value={"Nogales Sur"}>Nogales Sur</option>
                            <option value={"Nogales Norte"}>
                              Nogales Norte
                            </option>
                          </select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <Form.Group controlId="modoOP">
                    <div className="center">
                      <label>
                        Logo:{" "}
                        <i
                          title="Logo del negocio (Se usara para mostrar el negocio dentro de la aplicación)"
                          className="bx bxs-info-circle icon bx-xs"
                          onClick={handleInfo}
                        ></i>
                        <img
                          id="logo_img"
                          alt="Error al cargar imagen"
                          src={imageUrl}
                          height="150"
                          width="275"
                        />
                        <input
                          id="logoNeg"
                          type="file"
                          style={{ display: "none" }}
                          accept="image/png, image/jpeg"
                          multiple={false}
                          onChange={handleImageChange}
                        />
                      </label>
                    </div>
                  </Form.Group>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <Modal
          style={customModalStyles}
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          contentLabel="Confirmación"
        >
          <p>¿Desea actualizar la informacion?</p>
          <button style={{ marginRight: 5 }} onClick={handleConfirmModal}>
            Aceptar
          </button>
          <button onClick={handleCancelModal}>Cancelar</button>
        </Modal>
        <Modal
          style={customModalInfoStyles}
          isOpen={infoModal}
          onRequestClose={() => setInfoModal(false)}
        >
          <p>{textInfo}</p>
          <button
            style={{ marginRight: 5 }}
            onClick={() => setInfoModal(false)}
          >
            Aceptar
          </button>
        </Modal>
      </div>
      <div className="center-form">
        <Button variant="primary" className="button" onClick={handleSubmit}>
          <FontAwesomeIcon icon={faFloppyDisk} /> ACTUALIZAR
        </Button>
      </div>
    </div>
  );
}
